import { css } from '@emotion/react'
import styled from '@emotion/styled'
import React, { memo } from 'react'

export interface Props {
  className?: string
  onClick?: (e: any) => void
  variant?: Variant
}

export const Dot = memo(function Dot({
  className,
  onClick,
  variant = 'default',
}: Props) {
  return <Container className={className} onClick={onClick} variant={variant} />
})

const Container = styled.div<ContainerProps>`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  cursor: pointer;
  margin: 0 0.5625rem;
  position: relative;
  &:before,
  &:after {
    content: '';
    border-radius: 50%;
    position: absolute;
  }
  &:before {
    width: 0.25rem;
    height: 0.25rem;
    background: ${({ theme }) => theme.colors.variants.neutralLight5};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:after {
    width: 100%;
    height: 100%;
    border: 0.0625rem solid
      ${({ theme }) => theme.colors.variants.neutralLight5};
    border-radius: 50%;
    top: 0;
    left: 0;
    transition: 0.6s ease-in-out;
    transform: scale(0);
  }
  &.active {
    &:after {
      transform: scale(1);
    }
  }

  ${({ theme, variant }) => {
    switch (variant) {
      case 'invert':
        return css`
          &:before {
            background: ${theme.colors.variants.neutralDark2};
          }
          &:after {
            border-color: ${theme.colors.variants.neutralDark2};
          }
        `
    }
  }}

  @media (max-width: 1199px) {
    margin: 0 0.375rem;
  }
`

interface ContainerProps {
  variant: Variant
}

export type Variant = 'default' | 'invert'
